package org.hs_soft.runmynesto.domain.usecase.product.tab_price

import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_price.special_price.SpecialPriceModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.product.tab_price.CreateSpecialPriceRepository

class CreateSpecialPriceUseCase(
    private val repository: CreateSpecialPriceRepository
) {
    suspend operator fun invoke(
        productId: String,
        name: String,
        type: Int,
        dateFrom: String,
        startTime:String,
    ):SpecialPriceModel {
        return repository.createSpecialPrice(
            productId=productId,
            name=name,
            type = type,
            dateFrom=dateFrom,
            startTime=startTime
        )
    }


}